import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';

const DeepLinkHandler = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (Capacitor.getPlatform() !== 'android' && Capacitor.getPlatform() !== 'ios') {
      return;
    }

    const listener = App.addListener('appUrlOpen', (event) => {
      if (event?.url) {
        try {
          const parsed = new URL(event.url);
          const path = parsed.pathname;

          if (path.startsWith('/post-details/')) {
            const postId = path.split('/post-details/')[1];
            navigate(`/post-details/${postId}`);
          } else if (path.startsWith('/jobs-detail/')) {
            const jobId = path.split('/jobs-detail/')[1];
            navigate(`/jobs-detail/${jobId}`);
          } else if (path.startsWith('/profile/')) {
            const username = path.split('/profile/')[1];
            navigate(`/profile/${username}`);
          } else if (path.startsWith('/r/')) {
            const [, ,username, resumeId] = path.split('/');
            navigate(`/r/${username}/${resumeId}`);
          }
        } catch (err) {
          console.error('Invalid deep link:', err);
        }
      }
    });

    return () => {
      listener.remove();
    };
  }, [navigate]);

  return null;
};

export default DeepLinkHandler;
